import axios from 'axios'
import HttpHelper from 'Services/HttpHelper'

export async function getDictionary(country, page) {
    const url = `https://member-calls2.unicity.com/hot/dictionary/v2/publish/${country}/${page}`

    return (await axios.get(HttpHelper.Proxy({ originalUrl: url }))).data
}